import _ from 'lodash';
import * as types from './types';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';

const INITIAL_STATE = {
  fetchWHKITListLoading: false,
  wHKITListData: [],
  fetchWHKITListLoadingError: null,
  printWHKITLoadReportsLoading: false,
  printLoadingError: null,
  fetchTruckRouteListLoading: false,
  truckRouteListData: [],
  fetchTruckRouteListLoadingError: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.FETCH_WAREHOUSE_KITCHEN_LIST_LOADING: {
      return {
        ...state,
        fetchWHKITListLoading: action.payload,
      };
    }
    case types.WAREHOUSE_KITCHEN_LIST_DATA:
      return {
        ...state,
        wHKITListData: action.payload,
      };
    case types.FETCH_WAREHOUSE_KITCHEN_LIST_LOADING_ERROR:
      const fetchWHKITListLoadingError = action.payload.response;
      if (
        _.has(fetchWHKITListLoadingError, 'data.Errors') &&
        fetchWHKITListLoadingError.data.Errors.length
      ) {
        return {
          ...state,
          fetchWHKITListLoadingError: fetchWHKITListLoadingError.data.Errors,
        };
      }
      return {
        ...state,
        fetchWHKITListLoadingError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while fetching Warehouse/Kitchen list. Please try again.',
        },
      };


    case types.PRINT_WAREHOUSE_KITCHEN_LOAD_REPORTS_LOADING:
      return {
        ...state,
        printWHKITLoadReportsLoading: action.payload,
      };
    case types.PRINT_LOADING_ERROR:
      const printLoadingError = action.payload.response;
      if (
        _.has(printLoadingError, 'data.Errors') &&
        printLoadingError.data.Errors.length
      ) {
        return {
          ...state,
          printLoadingError: printLoadingError.data.Errors,
        };
      }
      return {
        ...state,
        printLoadingError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while printing Warehouse/Kitchen data. Please try again.',
        },
      };
    case types.FETCH_TRUCK_ROUTE_LIST_LOADING:
      return {
        ...state,
        fetchTruckRouteListLoading: action.payload,
      };
    case types.TRUCK_ROUTE_LIST_DATA:
      return {
        ...state,
        truckRouteListData: action.payload,
      };
    case types.FETCH_TRUCK_ROUTE_LIST_LOADING_ERROR:
      const fetchTruckRouteListLoadingError = action.payload.response;
      if (
        _.has(fetchTruckRouteListLoadingError, 'data.Errors') &&
        fetchTruckRouteListLoadingError.data.Errors.length
      ) {
        return {
          ...state,
          fetchTruckRouteListLoadingError:
          fetchTruckRouteListLoadingError.data.Errors,
        };
      }
      return {
        ...state,
        fetchTruckRouteListLoadingError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while fetching truck route data. Please try again.',
        },
      };

    case types.CLEAR_PRINT_LOADING_ERROR:
      return {
        ...state,
        fetchWHKITListLoadingError: null,
        printLoadingError: null,
        fetchTruckRouteListLoadingError: null,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/warehousepicklist/state/reducers.js